/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonBtcStakingHistoryListInfo } from '../models/BabylonBtcStakingHistoryListInfo';
import type { BabylonBtcStakingTransactionDetailHistoryRequest } from '../models/BabylonBtcStakingTransactionDetailHistoryRequest';
import type { BabylonBtcStakingTransactionListInfo } from '../models/BabylonBtcStakingTransactionListInfo';
import type { BabylonBtcStakingTransactionRequest } from '../models/BabylonBtcStakingTransactionRequest';
import type { BabylonBtcStakingTransactionSummaryRequest } from '../models/BabylonBtcStakingTransactionSummaryRequest';
import type { BabylonBtcStakingTrxDetailHistoryGroupListInfo } from '../models/BabylonBtcStakingTrxDetailHistoryGroupListInfo';
import type { BabylonBtcStakingTrxSummaryInfo } from '../models/BabylonBtcStakingTrxSummaryInfo';
import type { BabylonStakingSummaryInfo } from '../models/BabylonStakingSummaryInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class StakingControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getLatestBtcStakingTransactionList({
        requestBody,
    }: {
        requestBody: BabylonBtcStakingTransactionSummaryRequest,
    }): CancelablePromise<Array<BabylonBtcStakingTrxSummaryInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/staking/btc/transaction/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingTransactionList({
        requestBody,
    }: {
        requestBody: BabylonBtcStakingTransactionRequest,
    }): CancelablePromise<BabylonBtcStakingTransactionListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/staking/btc/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingTransactionHistoryList({
        requestBody,
    }: {
        requestBody: BabylonBtcStakingTransactionRequest,
    }): CancelablePromise<BabylonBtcStakingHistoryListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/staking/btc/transaction/history/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingTransactionDetailHistoryList({
        requestBody,
    }: {
        requestBody: BabylonBtcStakingTransactionDetailHistoryRequest,
    }): CancelablePromise<BabylonBtcStakingTrxDetailHistoryGroupListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/staking/btc/transaction/detail/history/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBtcStakingSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonStakingSummaryInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/staking/btc/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
